import { render, staticRenderFns } from "./group.vue?vue&type=template&id=4177e6e6&scoped=true&"
import script from "./group.vue?vue&type=script&lang=ts&"
export * from "./group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177e6e6",
  null
  
)

export default component.exports